import React from "react";
import { LinearProgress, Step, StepLabel, Stepper } from "@mui/material";
import { useTranslation } from "react-i18next";

const SleepCoachStepper = ({ currentStep, steps }) => {
  const {t} = useTranslation();
  return (
    <div className="mb-3">
      <h2 className="text-[20px] md:text-[24px] text-center font-[600] text-black-600 font-[Lato]">
        {t("sleepCoachPreferences.sleepCoachHeading")}
      </h2>
      <p className="text-[#535862] text-[16px] font-[400] font-[Lato] text-center md:mb-6">{t("sleepCoachPreferences.sleepCoachHeading")}</p>
      <LinearProgress
        variant="determinate"
        value={(currentStep / (steps.length - 1)) * 100}
        sx={{ height: 10, borderRadius: 5, display: "none" }}
      />
      <Stepper activeStep={currentStep} alternativeLabel className="mt-4">
        {steps.map((step) => (
          <Step key={step.title} completed={steps.indexOf(step) < currentStep}>
            <StepLabel
              className="labelStep"
              slotProps={{
                stepIcon: {
                  sx: {
                    fontSize: {
                      xs: "25px",
                      md: "40px",
                    },
                    fontWeight: 700,
                  },
                },
              }}
              sx={{
                "& .MuiStepLabel-label": {
                  fontSize: {
                    xs: "0px",
                    sm: "12px",
                    md: "14px",
                  },
                  display: {
                    xs: "none",
                    sm: "block",
                  },
                  fontWeight: "400",
                },
              }}
            >
              {/* {step.title} */}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default SleepCoachStepper;
